
import React, {useEffect, useState} from 'react';

import {FaArrowRight, FaTimes} from 'react-icons/fa';



const Team = () => {
    useEffect(()=>{
document.title = "Mosquito Nets | Pinnacle Concepts Limited";
},[]);


  return (
    <section className='section-cover team-cover equip-cover' >
         <div className='content-container products-container'>
          
          <h2 className="home-h2 furniture-h2">Mosquito Nets</h2>
             {/* <p className='about-intro-p'>Exotic Furniture</p> */}
         
            <div className='services-container-new'>
                <article className='single-service-new'>
    
              <div className='tools-slides-cover'>
                {/* <Tool1></Tool1> */}
                <img src='./images/177.jpg' class='item-image'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/CB/MN/001</h3>
          </article>
                <article className='single-service-new'>
    
              <div className='tools-slides-cover'>
                {/* <Tool1></Tool1> */}
                <img src='./images/178.jpg' class='item-image '></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/CB/MN/002</h3>
          </article>
          <article className='single-service-new'>
    
              <div className='tools-slides-cover'>
                {/* <Tool1></Tool1> */}
                <img src='./images/179.jpg' class='item-image '></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/CB/MN/003</h3>
          </article>
          <article className='single-service-new'>
         
              <div className='tools-slides-cover'>
                {/* <Tool2></Tool2> */}
                <img src='./images/180.jpg' class='item-image '></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/CB/MN/004</h3>
          
          </article>
          <article className='single-service-new'>
         
              <div className='tools-slides-cover'>
                {/* <Tool2></Tool2> */}
                <img src='./images/181.jpg' class='item-image '></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/CB/MN/005</h3>
          
          </article>
          <article className='single-service-new'>
         
              <div className='tools-slides-cover'>
                {/* <Tool2></Tool2> */}
                <img src='./images/182.jpg' class='item-image'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/CB/MN/006</h3>
          </article>
      </div>
         </div>
    </section>
  )
}

export default Team